window.mx = window.mx || {};

window.mx.MxHeader = class extends window.mx.MxSection {
  constructor() {
    super();
  }

  connectedCallback() {
    this.menuIcon.addEventListener("click", () => {
      this.onMenuIconClick();
    });

    for (const mobileChevron of this.querySelectorAll(
      "div.mobile-link, .mobile-link-chevron-container",
    )) {
      mobileChevron.addEventListener("click", () => {
        this.onMobileLinkChevronClick(mobileChevron);
      });
    }

    this.searchIcon.addEventListener("click", () => {
      this.onSearchIconClick();
    });

    this.cartIcon.addEventListener("click", (event) => {
      event.preventDefault();
      openCartDrawer();
    });

    window.addEventListener(
      "scroll",
      window.mx.throttle(() => this.onScroll()),
    );
    window.addEventListener("resize", this.onScroll.bind(this));
    this.onScroll();
  }

  get menuIcon() {
    return this.querySelector(".menu-icon-container");
  }
  get searchIcon() {
    return this.querySelector(".search-icon-container");
  }
  get accountIcon() {
    return this.querySelector(".account-icon-container");
  }
  get cartIcon() {
    return this.querySelector(".cart-icon-container");
  }
  get searchDrawer() {
    return this.querySelector(".header-search");
  }

  onScroll() {
    const announcementBar = document?.querySelector(".mx-announcement-bar");

    let scrollThreshold = announcementBar ? announcementBar.offsetHeight : 0;

    const topOffset = document.documentElement.style.top;
    const scrollPosition =
      window.scrollY - (topOffset ? parseInt(topOffset) : 0);

    if (scrollPosition > scrollThreshold) {
      this.section.setAttribute("data-sticky", "");
    } else {
      this.section.removeAttribute("data-sticky");
    }
  }
  onMenuIconClick() {
    const headerOverhead = this.getBoundingClientRect().top;
    this.section.style.setProperty("--header-overhead", `${headerOverhead}px`);

    this.section.toggleAttribute("data-mobile-menu");
    this.section.removeAttribute("data-search-drawer");
    this.searchDrawer.removeAttribute("open");

    this.section.hasAttribute("data-mobile-menu")
      ? window.mx.lockScroll()
      : window.mx.unlockScroll();
  }
  onMobileLinkChevronClick(chevron) {
    const associatedLinkContainer = chevron.parentElement;

    associatedLinkContainer.hasAttribute("data-active")
      ? associatedLinkContainer.removeAttribute("data-active")
      : associatedLinkContainer.setAttribute("data-active", "");
  }
  onSearchIconClick() {
    this.section.toggleAttribute("data-search-drawer");
    this.section.removeAttribute("data-mobile-menu");

    if (this.section.hasAttribute("data-search-drawer")) {
      window.mx.lockScroll();
      this.searchDrawer.setAttribute("open", "");
    } else {
      window.mx.unlockScroll();
      this.searchDrawer.removeAttribute("open");
    }
  }
};
if (!window.customElements.get("mx-header"))
  window.customElements.define("mx-header", window.mx.MxHeader);
